import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from '@/utils/axios';

export default function VaccinationCardPrintPage() {
  const { patientId } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [patient, setPatient] = useState(null);
  const [vaccinationCard, setVaccinationCard] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await axiosInstance.get(`/patients/${patientId}/vaccination-card`);
        setVaccinationCard(response.data);
        setPatient(response.data.patient);
        setLoading(false);
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
        setError(error.response?.data?.detail || 'Erro ao carregar cartão vacinal.');
        setLoading(false);
      }
    };
    fetchData();
  }, [patientId]);

  const handlePrint = () => {
    window.print();
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleDateString('pt-BR');
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'white' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>⏳</div>
          <p style={{ fontSize: '18px', color: '#666' }}>Carregando cartão vacinal...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'white' }}>
        <div style={{ textAlign: 'center', padding: '32px' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
          <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#333', marginBottom: '8px' }}>Erro ao carregar</h2>
          <p style={{ color: '#666', marginBottom: '16px' }}>{error}</p>
          <button 
            onClick={() => window.history.back()} 
            style={{ padding: '8px 16px', border: '1px solid #ccc', borderRadius: '4px', cursor: 'pointer' }}
          >
            Voltar
          </button>
        </div>
      </div>
    );
  }

  if (!vaccinationCard || !patient) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'white' }}>
        <div style={{ textAlign: 'center', padding: '32px' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>📋</div>
          <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#333', marginBottom: '8px' }}>Nenhum dado encontrado</h2>
          <button 
            onClick={() => window.history.back()} 
            style={{ padding: '8px 16px', border: '1px solid #ccc', borderRadius: '4px', cursor: 'pointer' }}
          >
            Voltar
          </button>
        </div>
      </div>
    );
  }

  const styles = {
    page: {
      background: 'white',
      minHeight: '100vh',
      fontFamily: 'Arial, sans-serif',
      fontSize: '12px',
      color: '#333'
    },
    container: {
      maxWidth: '900px',
      margin: '0 auto',
      padding: '20px'
    },
    noPrint: {
      position: 'fixed',
      top: '16px',
      right: '16px',
      zIndex: 1000,
      display: 'flex',
      gap: '8px'
    },
    button: {
      padding: '10px 20px',
      border: '1px solid #0d9488',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: 'bold'
    },
    printButton: {
      background: '#0d9488',
      color: 'white',
      border: 'none'
    },
    header: {
      textAlign: 'center',
      borderBottom: '4px solid #0d9488',
      paddingBottom: '16px',
      marginBottom: '20px'
    },
    title: {
      fontSize: '28px',
      fontWeight: 'bold',
      color: '#0d9488',
      margin: '0 0 8px 0'
    },
    subtitle: {
      fontSize: '12px',
      color: '#666',
      margin: 0
    },
    patientBox: {
      background: '#f0fdfa',
      border: '2px solid #99f6e4',
      borderRadius: '8px',
      padding: '16px',
      marginBottom: '20px'
    },
    patientGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '20px'
    },
    label: {
      fontSize: '10px',
      color: '#666',
      textTransform: 'uppercase',
      fontWeight: 'bold',
      marginBottom: '4px'
    },
    value: {
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#333'
    },
    summaryGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: '12px',
      marginBottom: '20px'
    },
    summaryCard: {
      padding: '16px',
      borderRadius: '8px',
      textAlign: 'center'
    },
    summaryNumber: {
      fontSize: '32px',
      fontWeight: 'bold'
    },
    summaryLabel: {
      fontSize: '11px',
      fontWeight: 'bold'
    },
    sectionTitle: {
      fontSize: '16px',
      fontWeight: 'bold',
      color: '#0d9488',
      borderBottom: '2px solid #e5e7eb',
      paddingBottom: '8px',
      marginBottom: '12px'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '11px',
      marginBottom: '20px'
    },
    th: {
      background: '#0d9488',
      color: 'white',
      padding: '10px 8px',
      textAlign: 'left',
      border: '1px solid #0d9488',
      fontWeight: 'bold'
    },
    thCenter: {
      background: '#0d9488',
      color: 'white',
      padding: '10px 8px',
      textAlign: 'center',
      border: '1px solid #0d9488',
      fontWeight: 'bold'
    },
    td: {
      padding: '8px',
      border: '1px solid #ddd'
    },
    tdCenter: {
      padding: '8px',
      border: '1px solid #ddd',
      textAlign: 'center'
    },
    footer: {
      borderTop: '2px solid #ddd',
      paddingTop: '16px',
      marginTop: '24px'
    },
    footerGrid: {
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: '10px',
      color: '#666',
      marginBottom: '16px'
    },
    notice: {
      background: '#fef9c3',
      border: '1px solid #fde047',
      borderRadius: '6px',
      padding: '12px',
      textAlign: 'center',
      fontSize: '10px',
      color: '#854d0e'
    }
  };

  return (
    <>
      <style>{`
        @media print {
          .no-print { display: none !important; }
          body { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
          @page { size: A4; margin: 10mm; }
        }
      `}</style>
      
      <div style={styles.page}>
        {/* Buttons - hidden in print */}
        <div className="no-print" style={styles.noPrint}>
          <button onClick={() => window.history.back()} style={styles.button}>
            ← Voltar
          </button>
          <button onClick={handlePrint} style={{...styles.button, ...styles.printButton}}>
            🖨️ Imprimir
          </button>
        </div>

        <div style={styles.container}>
          {/* Header */}
          <div style={styles.header}>
            <h1 style={styles.title}>💉 CARTÃO DE VACINAÇÃO</h1>
            <p style={styles.subtitle}>Recomendação SBIM e Ministério da Saúde do Brasil</p>
          </div>

          {/* Patient Info */}
          <div style={styles.patientBox}>
            <div style={styles.patientGrid}>
              <div>
                <p style={styles.label}>Nome do Paciente</p>
                <p style={styles.value}>{patient?.nome || 'N/A'}</p>
              </div>
              <div>
                <p style={styles.label}>Data de Nascimento</p>
                <p style={styles.value}>{patient?.data_nascimento || 'N/A'}</p>
              </div>
            </div>
          </div>

          {/* Summary */}
          <div style={styles.summaryGrid}>
            <div style={{...styles.summaryCard, background: '#dcfce7', border: '1px solid #86efac'}}>
              <p style={{...styles.summaryNumber, color: '#16a34a'}}>{vaccinationCard?.summary?.complete || 0}</p>
              <p style={{...styles.summaryLabel, color: '#16a34a'}}>Completas</p>
            </div>
            <div style={{...styles.summaryCard, background: '#dbeafe', border: '1px solid #93c5fd'}}>
              <p style={{...styles.summaryNumber, color: '#2563eb'}}>{vaccinationCard?.summary?.in_progress || 0}</p>
              <p style={{...styles.summaryLabel, color: '#2563eb'}}>Em Andamento</p>
            </div>
            <div style={{...styles.summaryCard, background: '#f3f4f6', border: '1px solid #d1d5db'}}>
              <p style={{...styles.summaryNumber, color: '#6b7280'}}>{vaccinationCard?.summary?.pending || 0}</p>
              <p style={{...styles.summaryLabel, color: '#6b7280'}}>Pendentes</p>
            </div>
            <div style={{...styles.summaryCard, background: '#fee2e2', border: '1px solid #fca5a5'}}>
              <p style={{...styles.summaryNumber, color: '#dc2626'}}>{vaccinationCard?.summary?.overdue || 0}</p>
              <p style={{...styles.summaryLabel, color: '#dc2626'}}>Atrasadas</p>
            </div>
          </div>

          {/* Vaccination History */}
          <h2 style={styles.sectionTitle}>✅ HISTÓRICO DE VACINAÇÕES APLICADAS</h2>
          {vaccinationCard?.records?.length > 0 ? (
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Vacina</th>
                  <th style={styles.thCenter}>Dose</th>
                  <th style={styles.thCenter}>Data</th>
                  <th style={styles.thCenter}>Lote</th>
                  <th style={styles.th}>Local</th>
                  <th style={styles.th}>Aplicador</th>
                </tr>
              </thead>
              <tbody>
                {vaccinationCard.records.map((record, idx) => (
                  <tr key={idx} style={{ background: idx % 2 === 0 ? 'white' : '#f0fdfa' }}>
                    <td style={{...styles.td, fontWeight: 'bold'}}>{record.vaccine_name}</td>
                    <td style={styles.tdCenter}>{record.dose_name}</td>
                    <td style={{...styles.tdCenter, fontWeight: 'bold', color: '#0d9488'}}>
                      {formatDate(record.vaccination_date)}
                    </td>
                    <td style={styles.tdCenter}>{record.lot_number || '-'}</td>
                    <td style={styles.td}>{record.healthcare_facility || '-'}</td>
                    <td style={styles.td}>{record.administered_by || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div style={{ textAlign: 'center', padding: '24px', background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px', marginBottom: '20px' }}>
              <p style={{ color: '#6b7280' }}>Nenhuma vacinação registrada</p>
            </div>
          )}

          {/* Vaccination Calendar */}
          <h2 style={styles.sectionTitle}>📋 CALENDÁRIO DE VACINAÇÃO</h2>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={{...styles.th, width: '40%'}}>Vacina</th>
                <th style={{...styles.thCenter, width: '12%'}}>Tipo</th>
                <th style={{...styles.thCenter, width: '18%'}}>Status</th>
                <th style={{...styles.thCenter, width: '12%'}}>Doses</th>
                <th style={{...styles.thCenter, width: '18%'}}>Última</th>
              </tr>
            </thead>
            <tbody>
              {vaccinationCard?.vaccination_status?.map((v, idx) => {
                const statusStyle = {
                  complete: { background: '#22c55e', color: 'white' },
                  in_progress: { background: '#3b82f6', color: 'white' },
                  overdue: { background: '#ef4444', color: 'white' },
                  pending: { background: '#f3f4f6', color: '#6b7280' }
                };
                const statusText = {
                  complete: '✓ Completa',
                  in_progress: '⏳ Andamento',
                  overdue: '⚠️ Atrasada',
                  pending: '○ Pendente'
                };
                const typeStyle = {
                  PNI: { background: '#dbeafe', color: '#1d4ed8' },
                  SBIM: { background: '#f3e8ff', color: '#7c3aed' },
                  AMBAS: { background: '#e0e7ff', color: '#4338ca' }
                };

                return (
                  <tr key={idx} style={{ background: v.status === 'complete' ? '#f0fdf4' : (idx % 2 === 0 ? 'white' : '#f9fafb') }}>
                    <td style={{...styles.td, fontWeight: 'bold'}}>{v.vaccine_name}</td>
                    <td style={styles.tdCenter}>
                      <span style={{
                        padding: '2px 8px',
                        borderRadius: '4px',
                        fontSize: '10px',
                        fontWeight: 'bold',
                        ...(typeStyle[v.type] || typeStyle.PNI)
                      }}>
                        {v.type}
                      </span>
                    </td>
                    <td style={{
                      ...styles.tdCenter,
                      fontWeight: 'bold',
                      ...(statusStyle[v.status] || statusStyle.pending)
                    }}>
                      {statusText[v.status] || '○ Pendente'}
                    </td>
                    <td style={styles.tdCenter}>{v.doses_taken}/{v.doses_required}</td>
                    <td style={styles.tdCenter}>
                      {v.last_vaccination ? formatDate(v.last_vaccination) : '-'}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {/* Legend */}
          <div style={{ display: 'flex', gap: '24px', marginBottom: '20px', fontSize: '11px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span style={{ width: '16px', height: '16px', background: '#22c55e', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '10px' }}>✓</span>
              <span>Completa</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span style={{ width: '16px', height: '16px', background: '#3b82f6', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '10px' }}>⏳</span>
              <span>Em andamento</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span style={{ width: '16px', height: '16px', background: '#ef4444', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '10px' }}>⚠️</span>
              <span>Atrasada</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span style={{ width: '16px', height: '16px', background: '#f3f4f6', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6b7280', fontSize: '10px' }}>○</span>
              <span>Pendente</span>
            </div>
          </div>

          {/* Footer */}
          <div style={styles.footer}>
            <div style={styles.footerGrid}>
              <div>
                <p style={{ margin: '0 0 4px 0' }}>Emitido em: {new Date().toLocaleDateString('pt-BR')} às {new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}</p>
                <p style={{ margin: 0 }}>Sistema de Gestão de Receitas Médicas</p>
              </div>
              <div style={{ textAlign: 'right' }}>
                <p style={{ margin: 0, fontWeight: 'bold', color: '#333' }}>São Domingos do Prata - MG</p>
              </div>
            </div>
            <div style={styles.notice}>
              <p style={{ margin: 0 }}><strong>⚠️ AVISO LEGAL:</strong> Este registro não substitui o cartão vacinal oficial do Ministério da Saúde. Os dados são de responsabilidade do profissional de saúde que realizou o registro.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
